export default __webpack_public_path__ + "static/media/firefox_2020-02-27_22-13-24.dc01f13c.png";